export default {
    DATE: {
        API: 'YYYY-MM-DD',
        UI: 'D.M.YYYY',
        FULL: 'MMMM Do YYYY',
        DATE_MONTH: 'MMMM DD',
    },
    DATETIME: {
        API: 'YYYY-MM-DD HH:mm:ss',
        UI: 'D.M.YYYY HH:mm',
    },
    UTILITY: {
        SAME_DAY: 'HH:mm',
        SAME_YEAR: 'DD.MM',
        DIFFERENT_YEAR: 'DD.MM.YYYY',
    },
    NUMBERS: {
        'fi-FI': {
            currency: {
                style: 'decimal',
            },
        },
    },
};
